/** @jsxImportSource @emotion/react */

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Title } from 'ui-components/Title'
import { CardList } from 'ui-components/CardList'
import { Pagination } from 'ui-components/Pagination'
import { SlideDialog } from 'ui-components/SlideDialog'
import { Button } from 'ui-components/Button'
import Add from '@material-ui/icons/Add'
import Search from '@material-ui/icons/Search'
import {
  Container,
  PaginationContainer,
  TopContainer,
  Buttons,
  showSearch,
  SearchForm,
  SearchFormContent,
  ListContainer,
} from './styles'

export default function ListPage(props) {
  const {
    renderForm,
    renderMenu,
    listTitle,
    onClickPagination,
    pagination,
    loading,
    children,
    showForm,
    onToggleForm,
    showAddButton,
    showSearchButton,
    renderSearchForm,
    openSearchForm,
  } = props

  const [showSearchForm, setShowSearchForm] = useState(openSearchForm)

  const handleSearch = () => {
    setShowSearchForm(!showSearchForm)
  }

  const renderAddButton = () => (
    <Button
      buttonType="floating"
      size="small"
      onClick={() => onToggleForm(true)}
    >
      <Add />
    </Button>
  )

  const renderSearchButton = () => (
    <Button
      buttonType="floating"
      size="small"
      onClick={handleSearch}
    >
      <Search />
    </Button>
  )

  const renderPagination = () => (
    <PaginationContainer>
      <Pagination
        showInfo
        onClick={onClickPagination}
        pagination={pagination}
        loading={loading}
      />
    </PaginationContainer>
  )

  const renderListForm = () => {
    if (!renderForm) return null

    return (
      <SlideDialog
        open={showForm}
        onClose={() => onToggleForm(false)}
      >
        { renderForm() }
      </SlideDialog>
    )
  }

  return (
    <>
      { renderListForm() }
      <Container>
        { renderMenu() }

        <CardList>
          <TopContainer>
            <Title title={listTitle} />
            <Buttons>
              { showSearchButton ? renderSearchButton() : null }
              { showAddButton ? renderAddButton() : null }
            </Buttons>
          </TopContainer>

          <SearchForm css={showSearchForm ? showSearch : ''}>
            <SearchFormContent css={showSearchForm ? showSearch : ''}>
              { renderSearchForm() }
            </SearchFormContent>
          </SearchForm>

          <ListContainer>
            { children }
          </ListContainer>

          { pagination ? renderPagination() : null }
        </CardList>
      </Container>
    </>
  )
}

ListPage.propTypes = {
  renderForm: PropTypes.func,
  renderMenu: PropTypes.func.isRequired,
  listTitle: PropTypes.string.isRequired,
  onClickPagination: PropTypes.func.isRequired,
  pagination: PropTypes.objectOf(PropTypes.any),
  loading: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]).isRequired,
  showForm: PropTypes.bool,
  onToggleForm: PropTypes.func.isRequired,
  showAddButton: PropTypes.bool,
  showSearchButton: PropTypes.bool,
  renderSearchForm: PropTypes.func,
  openSearchForm: PropTypes.bool,
}

ListPage.defaultProps = {
  renderForm: null,
  pagination: null,
  loading: false,
  showForm: false,
  showAddButton: false,
  showSearchButton: false,
  renderSearchForm: () => {},
  openSearchForm: false,
}
